import { ConsultantContractGeneratorType } from "../../consultant-contract-generator-type";
import {
  CanDownloadContext,
  CanGenerateByOneflowContext,
  CanPreviewContext,
  CanSendToOneflowContext,
  GetOneflowTemplateIdContext,
  IConsultantContractStrategy
} from "../consultant-contract-strategy";

export class OutsourceNationalContractStrategy implements IConsultantContractStrategy {
  public readonly name = "OutsourceNationalContractStrategy";

  canPublishToOneflowDirectly(ctx: CanSendToOneflowContext): boolean {
    return true;
  }

  canPublishToOneflowViaTicket(ctx: CanSendToOneflowContext): boolean {
    return true;
  }

  getOneflowGeneratorType(ctx: CanGenerateByOneflowContext) {
    return ctx.tenant === "wcc"
      ? ConsultantContractGeneratorType.OutsourceNationalTemplateDataGenerator
      : null;
  }

  getOneflowTemplateId(ctx: GetOneflowTemplateIdContext) {
    if (ctx.env === "dev" || ctx.env === "staging") {
      return ctx.tenant === "wcc"
        ? {
            workspaceId: "419741",
            templateId: "11859032"
          }
        : {
            workspaceId: "419741",
            templateId: "3929207"
          };
    }

    if (ctx.env === "production") {
      return ctx.tenant === "wcc"
        ? {
            workspaceId: "457689",
            templateId: "12120663"
          }
        : {
            workspaceId: "406174",
            templateId: "6246025"
          };
    }

    throw new Error("unknown env");
  }


  canDuplicate(): boolean {
    return true;
  }

  canEdit(): boolean {
    return true;
  }

  canPreview(ctx: CanPreviewContext): boolean {
    return ctx.tenant !== 'wcc';
  }

  canDownload(ctx: CanDownloadContext): boolean {
    return !!ctx.fileId
  }

  defaultSalaryChoice(): null {
    return null;
  }
}
